import { render, staticRenderFns } from "./u-sitemap-basic.vue?vue&type=template&id=e5452360&scoped=true"
import script from "./u-sitemap-basic.vue?vue&type=script&lang=js"
export * from "./u-sitemap-basic.vue?vue&type=script&lang=js"
import style0 from "./u-sitemap-basic.vue?vue&type=style&index=0&id=e5452360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5452360",
  null
  
)

export default component.exports